import React, { useCallback, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ADIDAS_SHOP_DOMAIN, ADIDAS_SHOP_DOMAIN_STAGING, GETTING_STARTED, IdntfyStore, MYKNITEVER_DOMAIN, TEST_SWAN_EXT_DOMAIN } from "../../vars";
import { MEDIA_TYPES, MediaContext } from "../../context/mediaContext";
import { UserDetailsContext } from "../../context/userDetails";
import StoreHomeCard from "../../components/defaultHome/StoreHomeCard";
import IdntfyHome from "../../components/idntfyHome/IdntfyHome";
import MykniteverHome from "../../components/myknitever/MykniteverHome";
import CustomModal from "../../components/customModal/CustomModal";
import QRCode from "../QRcode/QRCode";
import AdidasHome from "../../components/AdidasHome/AdidasHome";
import { handlePostHogCustomEvent } from "../../utils/util";

function Home() {
	const navigate = useNavigate();
	const { media } = useContext(MediaContext);
	const { shopDomain, scanType, email } = useContext(UserDetailsContext);
	const [open, setOpen] = useState(false);
	const QRCodeModal = CustomModal(QRCode);
	const handleClick = useCallback(() => {
		const event = `${shopDomain}/cta_click`;
		const timestamp = new Date().toISOString();
		let data = { scanType, timestamp };
		if (email) {
			data.email = email;
		}
		data = JSON.stringify(data);
		handlePostHogCustomEvent(event, { data });
		if (media === MEDIA_TYPES.MOBILE) {
			navigate(GETTING_STARTED);
		} else {
			setOpen(!open);
		}
	}, [media, open]);

	const renderComponent = useCallback(() => {
		switch (shopDomain) {
			case IdntfyStore:
				return <IdntfyHome handleClick={handleClick} />;
			case MYKNITEVER_DOMAIN:
				return <MykniteverHome handleClick={handleClick} />;
			case TEST_SWAN_EXT_DOMAIN:
				return <MykniteverHome handleClick={handleClick} />;
			case ADIDAS_SHOP_DOMAIN:
			case ADIDAS_SHOP_DOMAIN_STAGING:
				return <AdidasHome handleClick={handleClick} />;
			default:
				return <StoreHomeCard handleClick={handleClick} />;
		}
	}, [shopDomain, handleClick]);

	return (
		<>
			{renderComponent()}
			<QRCodeModal className="qr-modal-ui" showModal={open} handleShowModal={handleClick} handleClose={handleClick} />
		</>
	);
}

export default Home;
